export default __webpack_public_path__ + "static/media/info_grey.fe17b51f.svg";